module.exports = __webpack_public_path__ + "static/img/ex2.0c60961.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ex2.jpg
// module id = aewY
// module chunks = 1